import { useCallback } from "react";

import type { GoogleFreeBookingLinksSettingsI18nInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { UpdateGoogleFreeBookingLinksSettingsI18n } from "./mutation";

export const useUpdateGoogleFreeBookingLinksSettingsI18n = () => {
	const { mutationFunc } = useCustomMutation(UpdateGoogleFreeBookingLinksSettingsI18n);

	const updateGoogleFreeBookingLinksSettingsI18n = useCallback(
		async (input: GoogleFreeBookingLinksSettingsI18nInput) => {
			return await mutationFunc({
				variables: {
					input,
				},
			});
		},
		[mutationFunc],
	);

	return {
		updateGoogleFreeBookingLinksSettingsI18n,
	};
};
